import React from "react";
import {
  DashboardRounded,
  AccessTimeRounded,
  PeopleAltRounded,
  BusinessRounded,
  TaskAltRounded,
  AssessmentRounded,
  DescriptionRounded,
  RequestQuoteRounded,
  AccountCircleRounded,
  ReceiptRounded,
  BarChartRounded,
  FolderRounded,
  AttachMoneyRounded,
  EventNoteRounded,
  LogoutRounded,
  WorkRounded,
  CalendarMonthRounded,
  ArticleRounded,
  SettingsRounded,
  DataUsageRounded,
  EventBusyRounded
} from "@mui/icons-material";
import {
  HomeIcon,
  ClockIcon,
  DocumentIcon,
  DocumentTextIcon,
  UserGroupIcon,
  UserIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  BriefcaseIcon,
  CalendarIcon,
  ArrowRightIcon,
  LogoutIcon,
  CollectionIcon,
  TemplateIcon
} from "@heroicons/react/outline";

export const typeOfApplication = "USER";

export const menu = [
  {
    id: 1,
    title: "Employee",
    children: [
      { id: 2, title: "Manage Employee", path: "/manageemployee" },
      { id: 3, title: "Add Project", path: "/addproject" },
      { id: 4, title: "Add Employee Status", path: "/addemployeestatus" },
      { id: 5, title: "Update Project", path: "/updateproject" },
      { id: 6, title: "View Invoices", path: "/viewinvoices" },
    ],
  },
  {
    id: 7,
    title: "Client",
    children: [{ id: 8, title: "Add Client", path: "/addclient" }],
  },
  {
    id: 9,
    title: "Employee Profile",
    children: [{ id: 10, title: "EmployeeProfile", path: "/profile" }],
  },
  {
    id: 11,
    title: "Reports",
    children: [
      { id: 12, title: "Timesheet", path: "/timesheet" },
      { id: 13, title: "Projects", path: "/projects" },
      { id: 14, title: "Budget", path: "/budget" },
    ],
  },
];

export const statusOptions = [
  { label: "CPT", value: "CPT" },
  { label: "OPT", value: "OPT" },
  { label: "H1", value: "H1" },
  { label: "H4", value: "H4" },
  { label: "EAD", value: "EAD" },
  { label: "Green Card", value: "Green Card" },
  { label: "Citizen", value: "Citizen" },
];

export const AdminNavigation = [
  {
    name: "Dashboard",
    icon: DashboardRounded,
    href: "/",
    children: false,
    access: ["ADMIN","USER"]
  },
  {
    name: "Manage Timesheets", 
    icon: CalendarMonthRounded, 
    href: "/manage-timesheets", 
    children: false,
    access: ["ADMIN","USER"]
  },
  {
    name: "Employee",
    icon: PeopleAltRounded,
    children: false,
    href: "/manageemployee",
    access: ["ADMIN"]
  },
  {
    name: "Timesheet",
    icon: AccessTimeRounded,
    children: true,
    href: "/timesheets",
    access: ["ADMIN"],
    items: [
      {name:"Timesheet", href:"/timesheets"},
      { name: "To Be Approved", href: "/pendingTimesheets" },
    ],
  }, 
  {
    name: "Invoices",
    icon: AttachMoneyRounded,
    children: true,
    href: "/invoices",
    access: ["ADMIN"],
    items: [
      {name:"Invoices", href:"/invoices"},
      { name: "To Be Generated", href: "/pendingInovoices" },
    ],
  },
  { 
    name: "Client", 
    icon: BusinessRounded, 
    href: "/addclient", 
    children: false, 
    access: ["ADMIN"] 
  },
  {
    name: "Project",
    icon: WorkRounded,
    href: "/addproject",
    children: false,
    access: ["ADMIN"]
  },
  {
    name: "Reports",
    icon: AssessmentRounded,
    children: true,
    href: "/reports",
    access: ["ADMIN"],
    items: [
      { name: "Projects", href: "/projects" },
      { name: "Budget", href: "/budget" },
    ],
  },
  {
    name: "Documents",
    icon: ArticleRounded,
    href: "/documents",
    access: ["USER"],
    children: false,
  },
];

export const EmpNavigation = [
  { 
    name: "Dashboard", 
    icon: DashboardRounded, 
    href: "/", 
    children: false, 
    access: ["USER"] 
  },
  { 
    name: "Timesheet", 
    icon: CalendarMonthRounded, 
    href: "/manage-timesheets", 
    children: false,
    access: ["USER"]
  },
  {
    name: "Time Off",
    icon: EventBusyRounded,
    href: "/time-off",
    children: false,
    access: ["USER"]
  },
  {
    name: "Documents",
    icon: ArticleRounded,
    href: "/documents",
    children: false,
    access: ["USER"]
  },
];

export const primaryColor = "#111827";
